import styled from 'styled-components';
import { AppStyledProps } from '../../../../../types';

type T = AppStyledProps;

const Image = styled.img<T>`
  width: 1em;
  height: 1em;
  margin-right: 0.5em;
`;

const Text = styled.p<T>`
  font-size: 1em;
  text-align: center;
  line-height: normal;
  letter-spacing: 0.1px;
`;

const Container = styled.div<T>`
  display: flex;
  align-items: center;
`;

export { Container, Image, Text };
